import Loader from "../../../components/loader";
import { useBalancerPoolsData } from "../../../context/balancerPoolData";
import {
  useFetchMarginTrades,
  useMatchedTrades,
  useSettledTrades,
} from "../../../context/contractDataLoaderService";
import TradesTable from "./trades_table";
import { PoolType } from "../../poolDetail/balancer/types";
import WalletConnect from "../../../components/common/walletConnect/index";

import { useEffect, useState } from "react";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../../utils/helpers/networks";
import { providers } from "ethers";
import { useGlobal } from "../../../context/globalContext";

function TradesData(props) {
  const [allPoolTrades, setAllPoolTrades] = useState([]);
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  let { data: margionPoolsData, loading: marginLoading } = useBalancerPoolsData(
    PoolType.MarginIssue
  );

  let { data: secondaryPoolsData, loading: secondaryLoading } =
    useBalancerPoolsData(PoolType.SecondaryIssue);

  let { data: tradeDetails, loading: settleTradesLoading } = useSettledTrades();

  let { matchedTradesList: claimableTrades, loading: claimableLoading } =
    useMatchedTrades(secondaryPoolsData);

  const marginTrades = useFetchMarginTrades(margionPoolsData);

  let formattedData =
    marginTrades && tradeDetails
      ? [...marginTrades.allTradesData, ...tradeDetails, ...claimableTrades]
      : marginTrades
      ? [...marginTrades.allTradesData, ...claimableTrades]
      : tradeDetails
      ? [...tradeDetails, ...claimableTrades]
      : [...claimableTrades];

  return (
    <>
      {marginLoading ||
      marginTrades.loading ||
      claimableLoading ||
      secondaryLoading ||
      settleTradesLoading ? (
        <Loader />
      ) : null}
      <section className="d-flex flex-column align-items-start px-0 py-4">
        <div className="w-100">
          <h3 className="mb-3 d-flex">Trades</h3>
          <TradesTable
            {...props}
            data={formattedData || []}
            account={account}
            provider={provider}
            web3={web3}
            chainId={chainId}
          />
        </div>
      </section>
      <WalletConnect loggedIn={props.loggedIn} />
    </>
  );
}

export default function Trades(props) {
  return <TradesData {...props} />;
}
